module.exports = __webpack_public_path__ + "static/media/logo.86188d4f.png";